/**
 * WebGL Background Configuration
 * Centralized control for particle system across all pages
 */

export const webglConfig = {
  // Global toggle - set to false to disable everywhere
  enabled: false,
  
  // Default settings for all pages
  defaults: {
    particleCount: 4096,
    particleColor: 0x64b5f6,  // Blue
    movementSpeed: 10.0,
    cameraDistance: 200
  },
  
  // Page-specific configurations
  pages: {
    home: {
      enabled: false
    },
    
    agents: {
      enabled: false
    },
    
    about: {
      enabled: false
    },
    
    skills: {
      enabled: false
    },
    
    chatty: {
      enabled: false
    },
    
    blog: {
      enabled: false
    },
    
    contact: {
      enabled: false
    },
    
    // Only enable for project pages
    projects: {
      enabled: true,
      particleCount: 4096,
      particleColor: 0x64b5f6,  // Blue
      movementSpeed: 10.0,
      cameraDistance: 200
    }
  },
  
  // Performance settings
  performance: {
    // Reduce particles on mobile
    mobileParticleReduction: 0.5,
    
    // Disable effects on low-end devices
    disableOnLowPerformance: true,
    
    // Maximum particle count regardless of config
    maxParticleCount: 16384
  }
};

/**
 * Get WebGL configuration for a specific page
 * @param {string} pageName - Name of the page (e.g., 'home', 'agents')
 * @returns {object} Configuration object for the page
 */
export const getWebGLConfig = (pageName) => {
  // If globally disabled, return disabled config unless it's a project page
  if (!webglConfig.enabled && pageName !== 'projects') {
    return { enabled: false };
  }
  
  // Get page-specific config or use defaults
  const pageConfig = webglConfig.pages[pageName] || webglConfig.defaults;
  
  // Apply performance optimizations
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  
  if (isMobile && webglConfig.performance.mobileParticleReduction) {
    pageConfig.particleCount = Math.floor(
      pageConfig.particleCount * webglConfig.performance.mobileParticleReduction
    );
  }
  
  // Enforce maximum particle count
  if (pageConfig.particleCount > webglConfig.performance.maxParticleCount) {
    pageConfig.particleCount = webglConfig.performance.maxParticleCount;
  }
  
  return {
    enabled: true,
    ...webglConfig.defaults,
    ...pageConfig
  };
};

export default webglConfig;